$shm_textarea_code_view $mol_text_code
	render_visible_only false
	Rows $shm_textarea_code_rows
		render_visible_only <= render_visible_only
		rows <= rows
	Row* $shm_textarea_code_line
		numb_showed <= sidebar_showed
		numb <= row_numb*
		theme <= row_theme*
		text <= row_text*
		syntax <= syntax
		uri_resolve* <= uri_resolve*
		highlight <= highlight
